import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { h } from 'preact';
import { UIPlugin } from '@uppy/core'; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json

var packageJson = {
  "version": "4.2.0"
}; // set default options, must kept in sync with @uppy/react/src/ProgressBar.js

var defaultOptions = {
  fixed: false,
  hideAfterFinish: true
};
/**
 * Progress bar
 *
 */

var ProgressBar =
/*#__PURE__*/
function (_UIPlugin) {
  _inherits(ProgressBar, _UIPlugin);

  function ProgressBar(uppy, opts) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressBar).call(this, uppy, _objectSpread({}, defaultOptions, opts)));
    _this.id = _this.opts.id || 'ProgressBar';
    _this.title = 'Progress Bar';
    _this.type = 'progressindicator';
    _this.render = _this.render.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render(state) {
      var totalProgress = state.totalProgress; // before starting and after finish should be hidden if specified in the options

      var isHidden = (totalProgress === 0 || totalProgress === 100) && this.opts.hideAfterFinish;
      return h("div", {
        className: "uppy uppy-ProgressBar",
        style: {
          position: this.opts.fixed ? 'fixed' : 'initial'
        },
        "aria-hidden": isHidden
      }, h("div", {
        className: "uppy-ProgressBar-inner",
        style: {
          width: "".concat(totalProgress, "%")
        }
      }), h("div", {
        className: "uppy-ProgressBar-percentage"
      }, totalProgress));
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);

  return ProgressBar;
}(UIPlugin);

export { ProgressBar as default };
ProgressBar.VERSION = packageJson.version;